import React from "react";
import userManager from "../app/UserManager";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Route, Switch} from "react-router-dom";
import Conditions from "./Conditions";
import DirectDeposit from "./DirectDeposit";
import OfferAcceptance from "./OfferAcceptance";
import FirstDay from "./FirstDay";
import SecuredContent from "../common/SecuredContent";
import webservice from '../app/Webservice';
import Header from "../header/Header";
import NoOfferFound from "../common/NoOfferFound";
import {PAGES} from "../common/Shared";

const propTypes = {
	// the react router history object for pushing/redirecting
	history: PropTypes.object.isRequired,
	oidc: PropTypes.object,
	dataList: PropTypes.object.isRequired,
};

const defaultProps = {
	oidc: {},
};

const mapStateToProps = (state) => ({
	oidc: state.oidc,
	dataList: state.dataList,
});

// user is not being logged in so do normal routing
class NotLoginCallback extends React.Component {
	constructor(props) {
		super(props);

		this.getOffer = this.getOffer.bind(this);

		// get lists and then get the offer
		if (!props.dataList.careerSchedule || !props.dataList.careerSchedule.length) {
			webservice.dataLists().then(this.getOffer);
		} else {
			this.getOffer();
		}
	}

	getOffer() {
        webservice.offer.get(this.props.match.params.guid);
	}

	render() {
		return (!this.props.oidc.user || this.props.oidc.user.expired) ? userManager.signinRedirect() : (
				<React.Fragment>
					<Header guid={this.props.match.params.guid}/>
					<section className="section-content flex1">
						<SecuredContent>
							{() => (
								<Switch>
									<Route path={`/${PAGES.CONDITIONS}/:guid`} render={props => <Conditions {...props} />}/>
									<Route path={`/${PAGES.DIRECT_DEPOSIT}/:guid`} render={props => <DirectDeposit {...props} />}/>
									<Route path={`/${PAGES.OFFER_ACCEPTANCE}/:guid`} render={props => <OfferAcceptance {...props} />}/>
									<Route path={`/${PAGES.FIRST_DAY}/:guid`} render={props => <FirstDay {...props} />}/>
									<Route render={() => <NoOfferFound/>}/>
								</Switch>
							)}
						</SecuredContent>
					</section>
				</React.Fragment>
			);
	}
}

NotLoginCallback.propTypes = propTypes;
NotLoginCallback.defaultProps = defaultProps;

export default connect(mapStateToProps)(NotLoginCallback);
